import React, { useRef } from 'react';
import { List, AutoSizer } from 'react-virtualized';
import Scrollbars from 'react-scrollbars-custom';
import useTheme from '../../../../themes/hooks/UseTheme';
var ListImplementation = function (_a) {
    var items = _a.items, itemHeight = _a.itemHeight, itemRenderer = _a.itemRenderer, emptyRenderer = _a.emptyRenderer, onItemSelected = _a.onItemSelected;
    var theme = useTheme();
    var listRef = useRef();
    // const rowHeight = typeof itemHeight === 'function' ? itemHeight : itemHeight as any * 8//onUndefinedUseDefined(customItemHeight, theme.designGrid.base * warnAndFallbackOnUndefined(itemHeight));
    // ToDo: Use fallback for height!
    console.log(theme);
    return (React.createElement(AutoSizer, null, function (_a) {
        var height = _a.height, width = _a.width;
        return (React.createElement(Scrollbars, { onScroll: function (ev) {
                var _a;
                var scrollTop = ev.scrollTop, scrollLeft = ev.scrollLeft;
                var grid = (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.Grid;
                grid === null || grid === void 0 ? void 0 : grid.handleScrollEvent({
                    scrollTop: scrollTop,
                    scrollLeft: scrollLeft
                });
            }, style: {
                width: width,
                height: height
            } },
            React.createElement(List, { height: height, width: width, rowHeight: function (rowIndex) {
                    if (typeof itemHeight === 'function') {
                        return itemHeight(rowIndex.index) * 8;
                    }
                    return 3;
                }, rowCount: items.length, rowRenderer: function (_a) {
                    var index = _a.index, style = _a.style, key = _a.key;
                    return (React.createElement("div", { key: key, style: style, onClick: onItemSelected ? function () {
                            onItemSelected(items[index]);
                        } : undefined }, itemRenderer(items[index], index)));
                }, noRowsRenderer: emptyRenderer, ref: listRef, style: {
                    overflowX: false, overflowY: false
                } })));
    }));
};
export default ListImplementation;
//# sourceMappingURL=ListImplementation.js.map